module.exports = __webpack_public_path__ + "img/2.aff09bba.jpg";